<div id="page-content" class="inicio" id="retornos">
  <div class="row">
    <div class="col-sm-10 col-sm-offset-1">
      <form role="form" (ngSubmit)="submit($event)" *ngIf="!error">
          <div class="pull-right">
            <div *ngIf="cedente && cedentes.length > 1" class="dropdown">
              <label>Cedente</label>
              <button class="btn btn-default dropdown-toggle" type="button" id="dropdownMenu1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">{{ cedente.Descricao }}<span class="caret"></span>
              </button>
              <ul class="dropdown-menu" aria-labelledby="dropdownMenu1">
                <li (click)="selectCedente(cedente)" *ngFor="let cedente of cedentes"><a>{{ cedente.Descricao }}</a></li>
              </ul>
            </div>
            <div class="form-group">
              <label class="control-label">Arquivo</label>
              <label for="retorno-arquivo" class="input">{{ fileName || 'Selecionar arquivo...' }}</label>
              <input (change)="fileChange($event)" name="file" type="file" class="form-control" id="retorno-arquivo" class="file">
            </div>
            <button type="submit" id="btn-enviar-retorno" class="btn btn-registrar">Enviar Retorno</button>
          </div>
      </form>
      <div *ngIf="!loaded && !error" class="container-loading">
        <div class="btn btn-registrar loading"></div>
      </div>
      <div class="col-md-10 col-md-offset-1" *ngIf="error">
        <span class="error">Nenhuma informação disponível no momento</span>
        <span class="error">Tente novamente mais tarde</span>
      </div>

      <table id="master-detail-table-retorno" style="width: 100%"></table>
    </div>
  </div>
</div>
